import { EPublishInfoType, IPublishInfo } from '../../../redux/reducers';
import { ICheckPublishResponse } from '../../../repositories/monolith-python/v1/check-publish';
import { mapServicesToDeactivate } from './mapServicesToDeactivate';
import { mapMessage } from './mapMessage';

export function mapPublishInfo(response: ICheckPublishResponse): IPublishInfo {
  const {
    type,
    message,
    servicesToDeactivate,
    checkFailed,
  } = response || {};

  return {
    type: (type as unknown as EPublishInfoType) || null,
    message: mapMessage(message),
    servicesToDeactivate: mapServicesToDeactivate(servicesToDeactivate),
    checkFailed,
  };
}
